import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: string;
}
export function Input({
  className = '',
  label,
  helperText,
  error,
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-233">
      {label && <label className="block text-sm font-semibold text-[#24292f] mb-2" data-id="element-234">
          {label}
        </label>}
      <input className={`
          w-full px-3 py-1.5 text-sm rounded-md border bg-[#f6f8fa]
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:bg-white transition-all
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-[#d0d7de]'}
          ${className}
        `} {...props} data-id="element-235" />
      {helperText && !error && <p className="mt-1 text-xs text-[#57606a]" data-id="element-236">{helperText}</p>}
      {error && <p className="mt-1 text-xs text-red-600" data-id="element-237">{error}</p>}
    </div>;
}